module.exports = __webpack_public_path__ + "img/TechInfAttack2_ua.6476948f.webp";